export default __webpack_public_path__ + "8827d3515ccb806ce68569cf9199c37d.svg";